@if (candidate$ | async; as candidate) {
<div class="container pt-2 mt-3">
  <syn-pages-header title="Détails du candidat" subTitle="Détails du candidat" />
  <div class="flex justify-content-center">
    <div class="mb-3 mt-3">
      <syn-candidate-description-card [candidate]="candidate" />
    </div>
    <div class="mb-3">
      <syn-candidate-exams-list-widget class="candidate-assessments" [candidate]="candidate" />
    </div>
  </div>
</div>
}
